// This file is auto-generated during the build process
const VERSION = {
  buildDate: "2025-04-04T15:24:23.064Z",
  buildId: "dev-1743780263",
  gitCommit: "dev"
};

export default VERSION;
